import * as React from "react";
import { FeedItemUpcomingCompo } from "../../../server/feed/buildfeed";
import { Compo } from "../models/compos";
import { RLink } from "../DesignSystem/RLink";
import { Button } from "../DesignSystem/Button";
import { Countdown } from "../DesignSystem/Countdown";
import { TestIds } from "../testIds";
import { MusicalNoteIcon } from "@heroicons/react/24/solid";

export const FeedItemOngoingCompo = ({
  item,
  hideSubmitButton,
}: {
  item: FeedItemUpcomingCompo;
  hideSubmitButton?: boolean;
}) => {
  const compo = new Compo(item.compo);

  return (
    <div className="relative mb-6 overflow-hidden rounded-xl border-2 border-chips-gold/40 bg-white shadow-sm dark:border-chips-gold/20 dark:bg-slate-800">
      <div className="pointer-events-none absolute right-4 top-4">
        <MusicalNoteIcon className="h-24 w-24 text-chips-gold/15 dark:text-chips-gold/10" />
      </div>

      <div className="relative p-4">
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-chips-gold dark:text-chips-gold">
          Submissions Open
        </div>

        <RLink to={`/compo/${item.compo.id}`}>
          <h3
            className="text-2xl font-bold text-slate-800 hover:text-slate-600 dark:text-white dark:hover:text-slate-300"
            data-testid={TestIds.FeedCompoTitle}
          >
            {item.compo.name}
          </h3>
        </RLink>

        <div className="mt-2 text-sm text-slate-600 dark:text-slate-300">
          <Countdown minimal until={compo.stopDate} /> left to submit
        </div>
      </div>

      {!hideSubmitButton && (
        <div className="relative border-t border-slate-100 bg-slate-50 px-4 py-3 dark:border-white/5 dark:bg-slate-700/50">
          <Button
            to={`/compo/${item.compo.id}/submit`}
            variant="primary"
            grow={false}
            icon={<MusicalNoteIcon className="h-4 w-4" />}
          >
            Submit your entry
          </Button>
        </div>
      )}
    </div>
  );
};
